import type { ToolDefinition } from './types';
import { targetSizeTemplate, compressionSynonymTemplate, useCaseTemplate } from './templates';
import {
  phase1TargetSizeConfigs,
  phase1CompressionConfigs,
  phase1UseCaseConfigs,
  type TargetSizeConfig,
  type CompressionConfig,
  type UseCaseConfig,
} from './configs';

function generateTargetSizeTool(config: TargetSizeConfig): ToolDefinition {
  const content = targetSizeTemplate(config.size, config.keyword);
  return {
    ...content,
    slug: config.slug,
    pageType: 'target-size',
    searchIntent: 'reduce-size',
    schemaType: 'SoftwareApplication',
    canonicalPath: `/herramientas/${config.slug}`,
    toolExampleType: 'target-size',
    targetSize: config.size,
    relatedSlugs: [], // assigned later by relatedSlugs module
  };
}

function generateCompressionTool(config: CompressionConfig): ToolDefinition {
  const content = compressionSynonymTemplate(config.keyword, config.displayKeyword);
  return {
    ...content,
    slug: config.slug,
    pageType: 'compression',
    searchIntent: 'compress',
    schemaType: 'SoftwareApplication',
    canonicalPath: `/herramientas/${config.slug}`,
    toolExampleType: 'compression',
    relatedSlugs: [],
  };
}

function generateUseCaseTool(config: UseCaseConfig): ToolDefinition {
  const content = useCaseTemplate(config.useCase, config.context, config.detailText);
  return {
    ...content,
    slug: config.slug,
    pageType: config.pageType,
    searchIntent: config.pageType === 'optimization' ? 'optimize' : 'compress',
    schemaType: 'SoftwareApplication',
    canonicalPath: `/herramientas/${config.slug}`,
    toolExampleType: 'compression',
    relatedSlugs: [],
  };
}

export function generatePhase1Tools(): ToolDefinition[] {
  return [
    ...phase1TargetSizeConfigs.map(generateTargetSizeTool),
    ...phase1CompressionConfigs.map(generateCompressionTool),
    ...phase1UseCaseConfigs.map(generateUseCaseTool),
  ];
}
